// types for question reducer
export const GET_POSTS = 'GET_POSTS';
export const GET_POST = 'GET_POST';
export const GET_USER_POSTS = 'GET_USER_POSTS';
export const ADD_POST = 'ADD_POST';
export const DELETE_POST = 'DELETE_POST';
export const UPDATE_POST = 'UDATE_POST';
export const POST_ERROR = 'POST_ERROR';
export const CLEAR_POST_ERROR = 'CLEAR_POST_ERROR';
export const CLEAR_POSTS = 'CLEAR_POSTS';
export const CLEAR_POST = 'CLEAR_POST';
export const SET_CURRENT_POST = 'SET_CURRENT_POST';
export const CLEAR_CURRENT_POST = 'CLEAR_CURRENT_POST';
export const FILTER_POSTS = 'FILTER_POSTS';
export const CLEAR_FILTER = 'CLEAR_FILTER';

// types for alert reducer
export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';

// types for auth
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';
export const USER_LOADED = 'USER_LOADED';
export const AUTH_ERROR = 'AUTH_ERROR';
export const DELETE_AUTH_USER = 'DELETE_AUTH_USER';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';

// types for comments
export const GET_COMMENTS_OF_A_POST = 'GET_COMMENTS_OF_A_POST';
export const CLEAR_COMMENTS_WHEN_BACK = 'CLEAR_COMMENTS_WHEN_BACK';
export const SET_CURRENT_COMMENT = 'SET_CURRENT_COMMENT';
export const CLEAR_CURRENT_COMMENT = 'CLEAR_CURRENT_COMMENT';
export const GET_COMMENTS_ERROR = 'GET_COMMENTS_ERROR';
export const COMMENT_ERROR = 'COMMENT_ERROR';
export const UPDATE_COMMENT = 'UPDATE_COMMENT';
export const DELETE_COMMENT = 'DELETE_COMMENT';
export const ADD_COMMENT = 'ADD_COMMENT';

// types for users
export const GET_USERS = 'GET_USERS';
export const GET_USER = 'GET_USER';
export const CREATE_USER = 'CREATE_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const DELETE_USER = 'DELETE_USER';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const GET_COMMENTS_OF_A_USER = 'GET_COMMENTS_OF_A_USER';
export const GET_POSTS_OF_A_USER = 'GET_POSTS_OF_A_USER';
export const SET_PASSWORD = 'SET_PASSWORD';
export const CLEAR_CURRENT_USER = 'CLEAR_CURRENT_USER';
export const CLEAR_USER = 'CLEAR_USER';
export const USER_ERROR = 'USER_ERROR';
export const CLEAR_USER_ERRORS = 'CLEAR_USER_ERRORS';

//types for route Stats
export const GET_ROUTE_STATS = 'GET_ROUTE_STATS';
